/** A seeded pseudo-random source returning floats in [0, 1). */
export type Rng = () => number;

/** Mulberry32: tiny, fast and deterministic, so a seed always rebuilds the same cube. */
export function createRng(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function randomInt(rng: Rng, maxExclusive: number): number {
  return Math.floor(rng() * maxExclusive);
}

export function pick<T>(rng: Rng, list: readonly T[]): T {
  const value = list[randomInt(rng, list.length)];
  if (value === undefined) throw new Error('pick() called with an empty list');
  return value;
}

/** Fisher–Yates shuffle, in place. */
export function shuffle<T>(rng: Rng, list: T[]): T[] {
  for (let i = list.length - 1; i > 0; i--) {
    const j = randomInt(rng, i + 1);
    const tmp = list[i] as T;
    list[i] = list[j] as T;
    list[j] = tmp;
  }
  return list;
}
